import React from "react";
import PropTypes from "prop-types";
import { Table, Modal, Checkbox, Icon, Popover } from "antd";
import { Header, Footer } from "./Toolbar";
import { Columns } from "./Columns";
import JsonExport from "./JsonExport";
import ReportPrint from "../ReportPrint";
import CustomReport from "./CustomReport";
import CustomPrint from "./CustomPrint";
import PrintTest from "./CustomPrint/test";
import moment from "moment-jalaali";
import SimpleTable from "./simpleTable/SimpleTable";
import CustomTable from "../../../CustomTable";
import Form from "./FormStatus/Form";
import actions from "redux-form/lib/actions";
import { connect } from "react-redux";
import TestPrint from "./CustomPrint/test";
import { onCustomPrint,generateUnifiedTableContent } from "./tableUtils";
import { setParams, getRowSelected, calculateTableWidth, getRowClassName, exportReport } from "./helpers";

@autobind
@connect((state) => ({
  currentUser: state.Auth.currentUser,
  company: state.General.company,
}))
@autobind
/**
 *
 */
export default class AntTable extends React.PureComponent {
  static propTypes = {
    header: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    footer: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    dataSource: PropTypes.arrayOf(PropTypes.object),
    dataPrint: PropTypes.array,
    dataExport: PropTypes.array,
    columns: PropTypes.arrayOf(PropTypes.object),
    setSort: PropTypes.arrayOf(PropTypes.object),
    setFilter: PropTypes.arrayOf(PropTypes.object),
    getSort: PropTypes.func,
    getFilter: PropTypes.func,
    getMeta: PropTypes.func,
    rowSelection: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    onTableRowClick: PropTypes.func,
    onRowDoubleClick: PropTypes.func,
    onInfo: PropTypes.func,
    onAdd: PropTypes.func,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onSearch: PropTypes.func,
    activeItem: PropTypes.number,
    className: PropTypes.string,
    extraHeaderLeft: PropTypes.object,
    extraHeaderRight: PropTypes.object,
    totalRow: PropTypes.number,
    limit: PropTypes.number,
    current: PropTypes.number,
    onLimitCount: PropTypes.func,
    onPagination: PropTypes.func,
    onChangeTable: PropTypes.func,
    onSelectTable: PropTypes.func,
    onSelected: PropTypes.func,
    onSelectAllTable: PropTypes.func,
    onSort: PropTypes.func,
    onFilter: PropTypes.func,
    onMenuTouch: PropTypes.func,
    menu: PropTypes.func,
    loading: PropTypes.bool,
    jsPagination: PropTypes.bool,
    jsSort: PropTypes.bool,
    jsFilter: PropTypes.bool,
    haveSetting: PropTypes.bool,
    haveExport: PropTypes.bool,
    haveCustomExport: PropTypes.bool,
    haveCustomPrint: PropTypes.bool,
    havePrint: PropTypes.bool,
    helpTable: PropTypes.any,
    rowKey: PropTypes.string,
    printTitle: PropTypes.string,
    extraButton: PropTypes.func,
    add: PropTypes.object,
    info: PropTypes.object,
    edit: PropTypes.object,
    columnStatus: PropTypes.object,
    delete: PropTypes.object,
    leftButtons: PropTypes.object,
    rightButtons: PropTypes.object,
    properties: PropTypes.object,
    rowCounter: PropTypes.number,
    rowClassName: PropTypes.string,
    get: PropTypes.func,
    pagination: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    reportBuilder: PropTypes.bool,
  };
  static defaultProps = {
    leftButtons: {},
    rightButtons: {},
    columns: [],
    dataSource: [],
    dataPrint: [],
    dataExport: [],
    activeItem: undefined,
    rowSelection: true,
    pagination: true,
    totalRow: 0,
    limit: 0,
    current: 1,
    rowCounter: 0,
    rowKey: "id",
    rowClassName: undefined,
    onSort: () => {},
    onFilter: () => {},
    getSort: () => {},
    getFilter: () => {},
    getMeta: () => {},
    onChangeTable: () => {},
    onSelectTable: () => {},
    onSelectAllTable: () => {},
    menu: () => {},
    loading: false,
    onTableRowClick: () => {},
    onRowDoubleClick: () => {},
    setSort: [],
    setFilter: [],
    extraButton: () => {},
    header: true,
    footer: true,
    jsPagination: false,
    jsSort: false,
    jsFilter: false,
    haveSetting: false,
    haveExport: false,
    haveCustomExport: false,
    haveCustomPrint: false,
    havePrint: false,
    properties: {},
    helpTable: undefined,
    reportBuilder: false,
  };

  /**
   *
   * @param {object} props
   */
  constructor(props) {
    super(props);
    this.state = {
      dataSource: props.dataSource,
      params: props.params,
      selectedRowKeys: [],
      selectedRows: [],
      onClickRows: [],
      sort: props.setSort,
      filter: props.setFilter,
      meta: {},
      tableChange: {
        current: 0,
        pageSize: 10,
      },
      selectedColumns: [],
      showCustomReport: false,
      showCustomPrint: false,
      printTest: false,
      expandedRowKeys: [],
      modalVisibility: false,
      numberOfColumns: 0,
      footerItems: props.Footer,
      // Remove hoveredRow from state since it causes unnecessary re-renders
    };

    // Use a class property instead of state for tracking hover
    this.hoveredRow = null;
  }
  handleRowMouseEnter = (record) => {
    // // Store the hovered row as a class property instead of state
    // this.hoveredRow = record;
    // if (this.props.hasHover) {
    //   this.props.getDetaillOfHover(record);
    // }
  };

  /**
   *
   * @param {object} np
   */
  componentWillReceiveProps(np) {
    this.setState({
      sort: np.setSort,
      filter: np.setFilter,
      dataSource: np.dataSource,
      footerItems: np.Footer,
      tableChange: {
        current: 0,
        pageSize: 10,
      },
    });
  }
  componentDidUpdate() {
    this.setState({
      footerItems: this.props.Footer,
    });
  }
  handleExpandRow = (record) => {
    const { expandedRowKeys } = this.state;
    const key = record.key;
    const expandedKeys = [...expandedRowKeys];

    if (expandedKeys.includes(key)) {
      // Row is expanded, collapse it
      const index = expandedKeys.indexOf(key);
      expandedKeys.splice(index, 1);
    } else {
      // Row is collapsed, expand it
      expandedKeys.push(key);
    }

    this.setState({ expandedRowKeys: expandedKeys });
  };

  // renderExpandIcon = (row) => {
  //   const { expandedRowKeys } = this.state;
  //   const expanded = expandedRowKeys.includes(row.key);
  //   const iconClassName = expanded ? '-' : '+';

  //   return (
  //     <div>
  //     {expanded?<span
  //       className={iconClassName}
  //       style={{height:"32px",width:"32px", cursor:"pointer",textAlign:"center",display:"flex",alignItems:"center",justifyContent:"center"}}
  //       onClick={() => this.handleExpandRow(row)}
  //     >
  //         <Icon type="minus-square" style={{fontSize:"16px",textAlign:"center",display:"flex",alignItems:"center",justifyContent:"center"}}/>
  //    </span>:<span
  //       className={iconClassName}
  //       style={{height:"32px",width:"32px",cursor:"pointer",textAlign:"center",display:"flex",alignItems:"center",justifyContent:"center"}}
  //       onClick={() => this.handleExpandRow(row)}
  //     >
  //         <Icon type="plus-square" style={{fontSize:"16px",textAlign:"center",display:"flex",alignItems:"center",justifyContent:"center"}}/>
  //    </span>}
  //    </div>
  //   );
  // };

  renderExpandIcon = (row) => {
    const { expandedRowKeys } = this.state;
    const expanded = expandedRowKeys.includes(row.key);
    const iconClassName = expanded ? "-" : "+";

    return (
      <div>
        <span
          className={iconClassName}
          style={{
            height: "20px",
            width: "20px",
            cursor: "pointer",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={() => this.setState({ modalVisibility: true })}
        >
          <Icon
            onClick={() => this.setState({ modalVisibility: true })}
            type="plus-square"
            style={{
              fontSize: "12px",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </span>
      </div>
    );
  };
  /**
   *
   * @return {Array}
   */
  selected() {
    return this.state.selectedRows;
  }

  _onCellChange(key, dataIndex) {
    return (value) => {
      const dataSource = [...this.state.dataSource];
      const target = dataSource.find((item) => item.key === key);
      if (target) {
        target[dataIndex] = value;
        this.setState({ dataSource });
      }
    };
  }

  _setParams = (type, key = "", value = "", operator = "") => {
    setParams(this, type, key, value, operator);
  };

  _onSort = (key, value) => {
    console.log(`Sorting by ${key} in ${value} order`);
    this._setParams("sort", key, value);
  };

  _onFilter = (key, _filter) => {
    this._setParams("filters", key, _filter, "in");
  };

  _onSearch = () => {
    this.setState({ loading: true });
  };

  _handleColumnClick = (column) => {
    console.log("Column clicked:", column);
  };

  _pagination = (pageNumber) => {
    this._setParams("page", "", pageNumber);
  };

  _limitCount = (count) => {
    this._setParams("limit", "", count);
  };

  _onClickDateTimeFilter = (key, rageDate) => {
    this._setParams("filters", key, rageDate, "bt");
  };

  _onClickSearch = (key, value) => {
    this._setParams("filters", key, value, "eq");
  };

  _getRowSelected = () => getRowSelected(this);

  _xWidth = () => calculateTableWidth(this);

  _onExport = (item) => {
    if (item.key === "more") {
      this.setState({ showCustomReport: true });
    } else {
      exportReport(this, item.key);
    }
  };

  _onCustomReport = (props) => {
    const { dataExport, columns } = this.props;
    const { selectedColumns, footerItems } = this.state;

    let exporter = new JsonExport(
      dataExport,
      columns,
      selectedColumns,
      footerItems,
      props.data,
      {
        separator: props.config.separator,
        type: props.config.type,
        showTitle: props.config.showTitle,
        showFooter: props.config.showFooter,
        ignoreColumn: ["_more"],
        escape: "false",
        customHeader: props.config.customHeader,
        customFooter: props.config.customFooter,
      }
    );

    exporter.customExportAs(props.config.type, "export");
  };

  _onCancelCustomReport = () => {
    this.setState({ showCustomReport: false });
  };

  _onCancelCustomPrint = () => {
    this.setState({ showCustomPrint: false });
  };

  _onCustomPrint = (props) => {
    onCustomPrint(props, this);
  };

  _opPrint = (e) => {
    if (this.props.haveCustomPrint === true) {
      this.setState({ showCustomPrint: true });
    } else {
      this.setState({ showCustomPrint: true });
    }
  };

  _onCancel = () => {
    this.setState({ modalVisibility: false });
  };

  _columns = () => {
    const { columns, menu, rowCounter, jsSort, jsFilter, columnStatus, Footer } = this.props;
    const { tableChange, params, selectedColumns } = this.state;

    const config = {
      columns,
      sortKeys: params?.sort || [],
      filterKeys: params?.filters || [],
      onSort: this._onSort,
      onFilter: this._onFilter,
      onDateTimeFilter: this._onClickDateTimeFilter,
      onSearch: this._onClickSearch,
      jsSort,
      jsFilter,
      selectedColumns,
      onCellChange: this._onCellChange,
    };

    let _columns = [];
    let i = rowCounter > 0 ? (tableChange.current - 1) * tableChange.pageSize + rowCounter - tableChange.pageSize : 0;

    if (rowCounter > 0) {
      _columns.push({
        title: "",
        dataIndex: "_counter",
        key: "_counter",
        width: 50,
        render: () => <div style={{ textAlign: "center" }}>{i++}</div>,
      });
    }

    const __columns = new Columns(config);
    const columnsWithHandlers = __columns.map((col) => ({
      ...col,
      title: (
        <div onClick={() => this._handleColumnClick(col)} style={{ cursor: "pointer" }}>
          {col.title}
        </div>
      ),
    }));

    _columns.push(...columnsWithHandlers);

    if (menu) {
      _columns.push({
        title: "",
        dataIndex: "_more",
        key: "_more",
        width: 50,
        render: (_, record) => menu([record]),
      });
    }

    return _columns;
  };

  _onSettingChange = (params = {}) => {
    this.setState({ selectedColumns: params.selectedColumns });
  };

  componentDidMount() {
    const savedData = localStorage.getItem(
      `${this.props.company.code === 14806 ? [] : this.props.printTitle}`
    );
    if (savedData) {
      this.setState({ selectedColumns: JSON.parse(savedData) });
    }
  }

  componentDidUpdate() {
    localStorage.setItem(
      `${this.props.printTitle}`,
      JSON.stringify(this.state.selectedColumns)
    );
  }

  /**
   *
   * @return {Number}
   * @private
   */
  _xWidth() {
    return calculateTableWidth(this);
  }

  exportReportDate = (value) => {
    exportReport(this, value);
  };

  _onExport(item) {
    if (item.key === "more") {
      this.setState({ showCustomReport: true });
    } else {
      this.exportReportDate(item.key);
    }
  }

  _onCustomReport(props) {
    const { dataExport, columns } = this.props;
    const { selectedColumns, footerItems } = this.state;

    let exporter = new JsonExport(
      dataExport,
      columns,
      selectedColumns,
      footerItems,
      props.data,
      {
        separator: props.config.separator,
        type: props.config.type,
        showTitle: props.config.showTitle,
        showFooter: props.config.showFooter,
        ignoreColumn: ["_more"],
        escape: "false",
        customHeader: props.config.customHeader,
        customFooter: props.config.customFooter,
      }
    );

    exporter.customExportAs(props.config.type, "export");
  }

  _onCancelCustomReport() {
    this.setState({ showCustomReport: false });
  }

  _onCancelCustomPrint() {
    this.setState({ showCustomPrint: false });
  }


////////////////////////////
openNewWindow = (pagePrint, style) => {
  const { columns, printTitle, properties, dataPrint } = this.props;
  const { selectedColumns } = this.state;
  const newWindow = window.open("", "_blank");
  
  const PersonalInformation = dataPrint.map((table, index) => ({
    personName: table.props?.user?.profile?.firstName || "",
    personFamily: table.props?.user?.profile?.lastName || "",
    personCode: table.props?.user?.profile?.personnelId || "",
    recruitmentType: table.props?.recruitmentType || "-",
    department: table.props?.department ? `واحد : ${table.props.department}` : " ",
    pageNumber: index + 1,
  }));

  const isCustomMode = printTitle === "گزارش شهرداری بابلسر" || printTitle === "گزارش مجموع";
  const tableContent = generateUnifiedTableContent(PersonalInformation, pagePrint, isCustomMode, this.props, this.state);

  newWindow.document.write(`
    <html>
      <head>
        <title>پرینت ${printTitle}</title>
        <style type="text/css">
          @font-face { font-family: "samim"; src: url("/src/fonts/Samim-FD.ttf"); }
          @page { margin: 4mm 4mm; }
          @media print {
            body { -webkit-print-color-adjust: exact; font-family: samim, serif; overflow: inherit; }
            .cl { -webkit-print-color-adjust: exact; background: #000; }
          }
          body { text-align: right; font-family: samim, serif; direction: rtl; font-size: 6px; }
          @media print and (orientation: portrait) { body { size: A4; font-size: 7px; } }
          @media print and (orientation: landscape) { body { size: A4; } }
        </style>
      </head>
      <body style="font-family: 'samim' !important;">
        ${tableContent}
      </body>
    </html>
  `);

  newWindow.document.close();
};


  /////////////////////////////////
  _opPrint(e) {
    if (this.props.haveCustomPrint === true) {
      // this.setState({ printTest: true });
      // return (
      //   <div>
      //     <TestPrint />
      //   </div>
      // );
      // this.openNewWindow();
      this.setState({ showCustomPrint: true });
    } else {
      // this.openNewWindow();
      return (
        // <div>
        //   <TestPrint />
        // </div>zx
        this.setState({ showCustomPrint: true })
      );
    }
  }


  /**
   *
   * @param {*} err
   * @param {*} result
   * @param {String} action
   * @private
   */
  _onCancel() {
    this.setState({
      modalVisibility: false,
    });
  }
  /**
   *
   * @return {XML}
   */
  render() {
    const {
      selectedRows,
      selectedRowKeys,
      dataSource,
      showCustomReport,
      showCustomPrint,
      selectedColumns,
      printTest,
      expandedRowKeys,
      modalVisibility,
      onClickRows,
    } = this.state;
    const {
      loading,
      rowSelection,
      columns,
      haveExport,
      haveSetting,
      havePrint,
      helpTable,
      onPagination,
      header,
      footer,
      jsPagination,
      dataExport,
      onTableRowClick,
      activeItem,
      rowKey,
      pagination,
      dataPrint,
      printTitle,
      properties,
      className,
      extraHeaderLeft,
      extraHeaderRight,
      extraButton,
      onInfo,
      onAdd,
      onEdit,
      onDelete,
      onSearch,
      onSelected,
      totalRow,
      limit,
      current,
      onLimitCount,
      haveCustomExport,
      onChangeTable,
      onSelectTable,
      onSelectAllTable,
      haveCustomPrint,
      leftButtons,
      rightButtons,
      onRowDoubleClick,
      rowClassName,
      reportBuilder,
    } = this.props;

    const _rowSelection = rowSelection
      ? {
          selectedRows,
          selectedRowKeys,
          getCheckboxProps: (record) => {
            if (record.rowSelectionDisabled) {
              let index = selectedRows.findIndex((item) => {
                return item[rowKey] === record[rowKey];
              });
              if (index > -1) {
                selectedRows.splice(index, 1);
                index = selectedRowKeys.findIndex((item) => {
                  return item === record[rowKey];
                });
                if (index > -1) {
                  selectedRowKeys.splice(index, 1);
                }
                onChangeTable(selectedRowKeys, selectedRows);
              }
            }

            return {
              disabled: record.rowSelectionDisabled
                ? record.rowSelectionDisabled
                : false,
              defaultChecked: record.rowSelectionDisabled
                ? !record.rowSelectionDisabled
                : null,
            };
          },
          onChange: (selectedRowKeys, selectedRows) => {
            this.setState({ selectedRows, selectedRowKeys });
            onChangeTable(selectedRowKeys, selectedRows);
            onSelected(selectedRows);
          },
          onSelect: (record, selected, selectedRows) => {
            this.setState({ selectedRows });
            onSelectTable(record, selected, selectedRows);
            onSelected(selectedRows);
          },
          onSelectAll: (selected, selectedRows, changeRows) => {
            this.setState({ selectedRows });
            onSelectAllTable(selected, selectedRows, changeRows);
            onSelected(selectedRows);
          },
        }
      : undefined;

    const _columns = this._columns();
    const xWidth = this._xWidth();

    return (
      <div
        id="jtbl"
        style={{
          height: "100%",
        }}
      >
        {(!reportBuilder ||
          (reportBuilder && dataSource && dataSource.length < 2000)) && (
          <Table
            onRowMouseEnter={this.handleRowMouseEnter}
            onRowMouseLeave={this.handleRowMouseLeave}
            onRowClick={(record) => {
              onTableRowClick(record);
              this.setState({ onClickRows: record });
            }}
            // expandIconAsCell={false}
            expandedRowKeys={expandedRowKeys}
            onExpand={(expanded, record) => this.handleExpandRow(record)}
            onRowDoubleClick={onRowDoubleClick}
            onChange={(paging, filter, sort) => {
              this.setState({ tableChange: paging });
            }}
            rowKey={rowKey}
            rowSelection={_rowSelection}
            columns={_columns}
            expandRowByCl
            dataSource={dataSource}
            pagination={jsPagination && pagination}
            loading={loading}
            title={() =>
              header === true ||
              haveSetting === true ||
              helpTable !== undefined ||
              (haveExport === true && !app._.isEmpty(dataExport)) ||
              havePrint === true ||
              !app._.isEmpty(rightButtons) ||
              !app._.isEmpty(leftButtons) ||
              !app._.isEmpty(extraHeaderRight) ||
              !app._.isEmpty(extraHeaderLeft) ||
              !app._.isEmpty(extraButton) ? (
                <Header
                  leftButtons={leftButtons}
                  rightButtons={rightButtons}
                  selectedRows={this._getRowSelected()}
                  rowSelection={rowSelection}
                  extraRight={extraHeaderRight}
                  extraLeft={extraHeaderLeft}
                  extraButton={extraButton}
                  onInfo={onInfo}
                  onAdd={onAdd}
                  onEdit={onEdit}
                  onDelete={onDelete}
                  onSearch={onSearch}
                  haveSetting={haveSetting}
                  helpTable={helpTable}
                  haveExport={haveExport && !app._.isEmpty(dataExport)}
                  haveCustomExport={haveCustomExport}
                  onExport={this._onExport}
                  havePrint={havePrint}
                  onPrint={this._opPrint}
                  columns={columns}
                  onSettingChange={this._onSettingChange}
                  printTitle={printTitle}
                  allReport={this.props.report}
                />
              ) : (
                !header && header
              )
            }
            footer={() =>
              footer === true
                ? !jsPagination && (
                    <Footer
                      selectedRows={this._getRowSelected()}
                      rowSelection={rowSelection}
                      onInfo={onInfo}
                      onEdit={onEdit}
                      onDelete={onDelete}
                      totalRow={totalRow}
                      limit={limit}
                      current={current}
                      pagination={onPagination}
                      limitCount={onLimitCount}
                    />
                  )
                : !jsPagination && footer
            }
            rowClassName={(item) => getRowClassName(item, this)}
            scroll={{ x: xWidth, y: "100%" }}
            className={
              className
                ? className
                : `ant-jtable
              ${jsPagination ? "ant-jtable-jsPagination" : ""}
              ${!jsPagination && footer ? "ant-jtable-footer" : ""}
              ${
                !(jsPagination && pagination) && jsPagination
                  ? "ant-jtable-not-footer"
                  : ""
              }
              ${
                header === true ||
                haveSetting === true ||
                helpTable !== undefined ||
                (haveExport === true && !app._.isEmpty(dataExport)) ||
                havePrint === true ||
                !app._.isEmpty(rightButtons) ||
                !app._.isEmpty(leftButtons) ||
                !app._.isEmpty(extraHeaderRight) ||
                !app._.isEmpty(extraHeaderLeft) ||
                !app._.isEmpty(extraButton)
                  ? "haveHeader"
                  : ""
              }
          ctabel${dataSource.length}`
            }
            // onRowClick={(record) => {
            //   // onTableRowClick(record);
            // }}
          ></Table>
        )}

        {reportBuilder && dataSource && dataSource.length >= 2000 && (
          <div>
            <Header
              leftButtons={leftButtons}
              rightButtons={rightButtons}
              selectedRows={this._getRowSelected()}
              rowSelection={rowSelection}
              extraRight={extraHeaderRight}
              extraLeft={extraHeaderLeft}
              extraButton={extraButton}
              onInfo={onInfo}
              onAdd={onAdd}
              onEdit={onEdit}
              onDelete={onDelete}
              onSearch={onSearch}
              haveSetting={haveSetting}
              helpTable={helpTable}
              haveExport={haveExport && !app._.isEmpty(dataExport)}
              haveCustomExport={haveCustomExport}
              onExport={this._onExport}
              havePrint={havePrint}
              onPrint={this._opPrint}
              columns={columns}
              onSettingChange={this._onSettingChange}
              printTitle={printTitle}
              allReport={this.props.report}
            />

            <SimpleTable dataSource={dataSource} columns={columns} />
          </div>
        )}

        {haveExport && showCustomReport && haveCustomExport && (
          <CustomReport
            items={_columns}
            visible={showCustomReport}
            onCancel={this._onCancelCustomReport}
            onExport={this._onCustomReport}
          />
        )}
        {/* {showCustomPrint && haveCustomPrint && (
          <CustomPrint
            items={_columns}
            visible={showCustomPrint}
            selectedColumns={selectedColumns}
            dataPrint={dataPrint}
            printTitle={printTitle}
            columns={columns}
            properties={properties}
            onCancel={this._onCancelCustomPrint}
            onExport={this._onCustomPrint}
          />
        )} */}
        {printTest && haveCustomPrint && (
          <PrintTest
            visible={printTest}
            onCancel={() => {
              this.setState({ printTest: false });
            }}
            onSubmit={(v) => _onCustomPrint(v)}
          />
        )}

        {modalVisibility ? (
          <div>
            <Form
              title={app.translate(``)}
              visible={true}
              // active={active}
              // type={type}
              // // onOk={this._onSubmit}
              onCancel={this._onCancel}
              onCancelTouch={this._onCancel}
              onClickRows={onClickRows}
              // formTitle={formTitle}
              // columnTitle={columnTitle}
              // rowClick={rowClick}
              // onChangeTypeSubmit={this._onChangeTypeSubmit}
              // onSubmitTouch={this._onSubmit}
              // paragraph={paragraph}
              // fromTime={fromTime}
              // toTime={toTime}
              // getPositionId={getPositionId}
              // valueType={valueType}
              // typeSubmit={typeSubmit}
            />
          </div>
        ) : (
          ""
        )}
        {showCustomPrint && (
          <TestPrint
            visible={showCustomPrint}
            onCancel={this._onCancelCustomPrint}
            onSubmit={this.openNewWindow}
          />
        )}
        {/* <CustomTable
          dataPrint={dataPrint}
          printTitle={printTitle}
          columns={columns}
          dataSource={dataSource}
          selectedColumns={selectedColumns}
          properties={properties}
        /> */}
      </div>
    );
  }
}
